import { useContext } from "react";

import { ShopContext } from "../contexts/ShopContext";

const useShopContext = () => {
  const context = useContext(ShopContext);

  if (!context) throw new Error("Shop context must be use inside Provider");

  return context;
};

export default useShopContext;
